import { Form, FormProps, Input, InputProps, Space } from "antd";
import styled from "styled-components";

interface ISearchFilter {
  label?: string;
  placeholder?: string;
  form?: FormProps["form"];
  name?: string;
  onChange?: (value: any) => void;
}

const StyledSpace = styled(Space)`
  display: flex;
  .ant-space-item:first-child {
    flex-grow: 1;
  }
`;

const SearchFilter = ({
  label,
  placeholder,
  form,
  name,
  onChange,
}: ISearchFilter) => {
  const handleChange: InputProps["onChange"] = (e) => {
    if (form && name)
      form?.setFieldValue(
        name,
        e.target.value === "" ? undefined : e.target.value
      );
    if (onChange) onChange(e.target.value);
  };
  return (
    <>
      <StyledSpace>
        <Form.Item name={name} style={{ margin: 0 }} label={label}>
          <Input.Search
            style={{ width: "100%" }}
            placeholder={placeholder}
            onChange={handleChange}
          />
        </Form.Item>
      </StyledSpace>
    </>
  );
};

export default SearchFilter;
